var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCsv = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 44 50",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#csv_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#csv_svg__b)",
  d: "M25 1H8a4 4 0 0 0-4 4v40a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4V16L25 1Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinejoin: "round",
  strokeOpacity: 0.1,
  strokeWidth: 0.5,
  d: "M40.25 45A4.25 4.25 0 0 1 36 49.25H8A4.25 4.25 0 0 1 3.75 45V5A4.25 4.25 0 0 1 8 .75h17l.049.005a.25.25 0 0 1 .128.068l15 15a.25.25 0 0 1 .073.177v29Z"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#csv_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M39.83 15.83 25.17 1.17a.1.1 0 0 0-.17.071V12a4 4 0 0 0 4 4h10.759a.1.1 0 0 0 .07-.17Z"
})), /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 12,
  y: 29,
  fill: "currentColor",
  rx: 3
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M20.956 37.671h-1.139l-2.333-5.386h1.393l1.543 3.568a997.907 997.907 0 0 0 1.582-3.568h1.307l-2.354 5.386Zm-8.69-.332v-1.442c.545.362.984.574 1.326.656h-.005c.338.077.632.12.888.12.361 0 .622-.058.761-.154.121-.091.184-.207.184-.328a.268.268 0 0 0-.068-.183v.005c-.067-.072-.265-.179-.554-.294a6.967 6.967 0 0 0-.28-.116l-.569-.222c-.612-.241-1.075-.511-1.254-.733a1.377 1.377 0 0 1-.289-.882c0-.468.178-.863.55-1.167.357-.3.911-.449 1.668-.449a5.51 5.51 0 0 1 1.726.294v1.235c-.728-.27-1.316-.395-1.76-.395-.299 0-.535.053-.694.154-.125.072-.188.159-.188.26 0 .097.053.174.154.236.145.092.42.213.777.343l.385.14h-.004l.173.067c.55.193.93.415 1.162.656h-.005c.256.265.381.598.381.974 0 .502-.193.907-.578 1.23-.367.308-.945.463-1.717.463-.66 0-1.38-.155-2.17-.468ZM10.882 36.2v1.26c-.68.236-1.277.347-1.798.347-1.601.01-2.782-1.216-2.763-2.826 0-.805.265-1.485.795-2.02.53-.54 1.172-.81 1.924-.81.521 0 1.138.115 1.842.356V33.8c-.752-.338-1.335-.516-1.77-.516-.26 0-.506.067-.737.202-.227.116-.395.318-.516.588-.135.28-.193.579-.193.873 0 .395.14.8.371 1.153.232.313.627.501 1.129.501.15 0 .328-.014.496-.038.174-.02.598-.15 1.22-.362Zm-6.604 1.684a.945.945 0 0 1-.68-.285v.005a.936.936 0 0 1-.29-.69c0-.265.097-.5.295-.68h-.005a.945.945 0 0 1 .68-.284c.265 0 .492.097.675.28.198.183.294.42.294.685a.933.933 0 0 1-.29.684.929.929 0 0 1-.68.285Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "csv_svg__b",
  x1: 22,
  x2: 22,
  y1: 1,
  y2: 49,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F9FBFC"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "csv_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h44v50H0z"
})), /*#__PURE__*/React.createElement("filter", {
  id: "csv_svg__c",
  width: 22.859,
  height: 22.858,
  x: 21,
  y: -1.858,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_10832_4967"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_10832_4967",
  result: "effect2_dropShadow_10832_4967"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow_10832_4967",
  result: "shape"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCsv);
export default ForwardRef;